export const CHANGE_GROUP = 'CHANGE_GROUP'
export const LOAD_MORE = 'LOAD_MORE'
export const UPDATE_TICKERS_IN_PORTFOLIO = 'UPDATE_TICKERS_IN_PORTFOLIO'
export const UPDATE_TICKERS_IN_UNIVERSAL = 'UPDATE_TICKERS_IN_UNIVERSAL'
export const UPDATE_PRICES = 'UPDATE_PRICES'
export const UPDATE_PRICE_LOADING = 'UPDATE_PRICE_LOADING'
export const UPDATE_EVENTS = 'UPDATE_EVENTS'
export const UPDATE_EVENTS_LOADING = 'UPDATE_EVENTS_LOADING'
export const UPDATE_FUNDAMENTAL_CHARTS = 'UPDATE_FUNDAMENTAL_CHARTS'
export const UPDATE_FUNDAMENTAL_LOADING = 'UPDATE_FUNDAMENTAL_LOADING'
export const UPDATE_ESTIMATES = 'UPDATE_ESTIMATES'
export const UPDATE_BOND_INVESTORS = 'UPDATE_BOND_INVESTORS'
export const UPDATE_HIGH_CONVICTION = 'UPDATE_HIGH_CONVICTION'
export const UPDATE_BEHAVIOR_CHART_LOADING = 'UPDATE_BEHAVIOR_CHART_LOADING'
export const UPDATE_SHOW_BEHAVIOUR_CHART = 'UPDATE_SHOW_BEHAVIOUR_CHART'
export const PORTFOLIO_DATA = 'PORTFOLIO_DATA'
export const SET_LOADING = 'SET_LOADING'
export const CURRENT_SCROLL_POSITION = 'CURRENT_SCROLL_POSITION'
export const SET_BOTTOM = 'SET_BOTTOM'
export const DELETE_TICKER = 'DELETE_TICKER'
export const SET_COMPANIES = 'SET_COMPANIES'
export const CLEAN_UP = 'CLEAN_UP'
export const CHANGE_SEARCH_INPUT_VALUE = 'CHANGE_SEARCH_INPUT_VALUE'
export const CHANGE_IMPLIED_RATING = 'CHANGE_IMPLIED_RATING'
export const CHANGE_RISK_STATUS = 'CHANGE_RISK_STATUS'
export const CHANGE_CREDIT_RISK_STATUS = 'CHANGE_CREDIT_RISK_STATUS'
export const CHANGE_SECTOR = 'CHANGE_SECTOR'
export const CHANGE_INDUSTRY = 'CHANGE_INDUSTRY'
export const CHANGE_COUNTRY = 'CHANGE_COUNTRY'
export const CHANGE_REGION = 'CHANGE_REGION'
export const CHANGE_SELECTED_TAB = 'CHANGE_SELECTED_TAB'
export const CHANGE_SELECTED_RISK_TAB = 'CHANGE_SELECTED_RISK_TAB'
export const SET_EXISTED_CREDIT_RISK = 'SET_EXISTED_CREDIT_RISK'
export const SET_ACTIVE_NODE = 'SET_ACTIVE_NODE'
export const SET_SHOW_BEHAVIOURAL = 'SET_SHOW_BEHAVIOURAL'
export const SET_SHOW_PEER_TOGGLE = 'SET_SHOW_PEER_TOGGLE'
export const SET_SHOW_COMPANY_TOGGLE = 'SET_SHOW_COMPANY_TOGGLE'
export const REMOVE_COMPANY = 'REMOVE_COMPANY'
export const UPDATE_CREDIT_PANEL_LOADING = 'UPDATE_CREDIT_PANEL_LOADING'
export const UPDATE_CREDIT_PANEL_DATA = 'UPDATE_CREDIT_PANEL_DATA'
export const UPDATE_CREDIT_DATA_COMPARISON_LOADING =
  'UPDATE_CREDIT_DATA_COMPARISON_LOADING'
export const UPDATE_CREDIT_DATA_COMPARISON = 'UPDATE_CREDIT_DATA_COMPARISON'
export const DELETE_CREDIT_DATA_COMPARISON = 'DELETE_CREDIT_DATA_COMPARISON'

export const UPDATE_NOTES_LOADING = 'UPDATE_NOTES_LOADING'
export const UPDATE_NOTES_DATA = 'UPDATE_NOTES_DATA'

export const GET_WHAT_IF_LOADING = 'GET_WHAT_IF_LOADING'
export const GET_WHAT_IF_DATA = 'GET_WHAT_IF_DATA'

export const CALCULATE_WHAT_IF_LOADING = 'CALCULATE_WHAT_IF_LOADING'
export const CALCULATE_WHAT_IF_DATA = 'CALCULATE_WHAT_IF_DATA'
export const CLEAR_CALCULATE_WHAT_IF_DATA = 'CLEAR_CALCULATE_WHAT_IF_DATA'

export const UPDATE_PRICES_CURRENCY = 'UPDATE_PRICES_CURRENCY'
export const SET_LOADING_ADD_DELETE_TICKER = 'SET_LOADING_ADD_DELETE_TICKER'
